"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;

var styles = function styles(theme) {
  return {
    root: {
      width: "100%",
      margin: "auto",
      marginBottom: "0",
      flexShrink: 0,
      display: "flex",
      alignItems: "center",
      fontFamily: theme.typography.fontFamily,
      backgroundColor: theme.palette.grey[100],
      border: "none",
      borderTop: "1px solid rgba(0,0,0,.04)",
      zIndex: "6",
      minHeight: theme.mixins.toolbar.minHeight,
      "& > svg": {
        maxHeight: "1rem",
        padding: "0 0 0 2rem",
        maxWidth: "100%",
        width: "100%",
        zIndex: "2"
      }
    },
    icon: {
      color: theme.palette.text.secondary,
      paddingLeft: "2rem",
      paddingRight: "1rem"
    },
    selected: {
      color: theme.palette.text.secondary,
      fontSize: ".8rem",
      padding: "1rem",
      paddingLeft: "0",
      fontWeight: "400",
      userSelect: "none",
      textAlign: "left"
    },
    selectedArrow: {
      paddingRight: "5rem"
    },
    toggle: {
      color: theme.palette.text.secondary
    },
    arrowContainer: {
      right: "1rem",
      position: "absolute",
      zIndex: 2,
      "& svg": {
        transition: "transform 240ms"
      }
    },
    arrowContainerOpen: {
      "& svg": {
        transform: "scaleY(-1)"
      }
    }
  };
};

exports.styles = styles;